import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import ioc from './modules/ioc'
import sys from './modules/sys'

Vue.use(Vuex);
let modules = {
  common,
  ioc,
  sys
}
// 实例化Store
const store = new Vuex.Store({
  modules: modules
})

export default store